import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-26eae6d3")

_pushScopeId("data-v-26eae6d3")
const _hoisted_1 = { class: "group" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("a", {
      class: ["item", { active: $props.modelValue === $setup.Position.LEFT }],
      onClick: _cache[1] || (_cache[1] = $event => ($setup.change($setup.Position.LEFT)))
    }, " 左 ", 2),
    _createVNode("a", {
      class: ["item", { active: $props.modelValue === $setup.Position.RIGHT }],
      onClick: _cache[2] || (_cache[2] = $event => ($setup.change($setup.Position.RIGHT)))
    }, " 右 ", 2)
  ]))
})